import { Helmet } from 'react-helmet'
import {PhoneLink} from '../../components/Shared/Links'

export default function Pairing(){
  return (
    <div className="pageStyles pairing">
      <Helmet>
        <title>Wine Pairing Events at Villaggio Grille</title>
        <meta name="description" content="Every month, Villaggio Grille hosts a wine dinner showcasing a different vineyard. With the amazing dishes they create to accompany each wine, every dinner becomes a four-course experience that your taste buds will thank you for." />
      </Helmet>

      <div className="events-listing-page custStylePTA">
        <div id="page-title" className="pt-bkg-image image-events">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="title-container less">
                  <h1>March Wine Pairing</h1>
                  <h4 className="one">
                    March 26th &nbsp;&middot;&nbsp; 6pm 
                    <span className="rules"> &nbsp;&middot;&nbsp; </span>
                    <br className="rules" />
                    $60 per guest
                    <br className="fullBr" />
                    Hosted by International Wines
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="sectionWrap insideNrw food-menus no-padding">
            <div className="intro">
              <p className="res">For Reservations: <span><PhoneLink /></span></p>
            </div>
            <div className="clearfix"></div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>
            
            <div className="course">
              <div className="service-box-2">
                <h3>Course One</h3>
                <h4>Mushroom Marsala Baked Brie</h4>
                <h5>Mini Baked Brie Wheel · Topped with Mushrooms, Marsala Sauce, &amp; Pine Nuts · Served with Mini Naan</h5>
                <p>Paired with</p>
                <h4>A Telleira · Godello · Ribeiro '24</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Two</h3>
                <h4>Mediterranean Snapper</h4>
                <h5>
                  Grilled Red Snapper · Tossed in Lemon Juice &amp; Olive Oil · Topped with Sautéed Onion &amp; Swiss Chard, Cherry 
                  Tomatoes, Black Olives, Feta Cheese, &amp; Parsley · Served Over Lemon Orzo </h5>
                <p>Paired with</p>
                <h4>Montaña · Blanco '20</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Three</h3>
                <h4>Lamb Meatballs</h4>
                <h5>Smoked Bacon, Roasted Tomato, &amp; Gouda Polenta · Tzatziki Sauce</h5>
                <p>Paired with</p>
                <h4>Montaña · Rioja Crianza '21</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Four</h3>
                <h4>Lemon Blueberry Cheesecake</h4>
                <h5>Lemon &amp; Blueberries infused in a New York Style Cheesecake · Blueberry Compote, Graham Cracker Crust, &amp; Whipped Cream</h5>
                <p>Paired with</p>
                <h4>Mont Marcal · Cava Brut Reserva '23</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
